import {Injectable} from '@angular/core'
import {HttpClient} from '@angular/common/http'
import {map, Observable} from 'rxjs'
import {
  AccountingModel,
  JournalCreditModel,
  JournalDebitModel,
  JournalTextsModel,
} from "../../../domain/src/lib/accounting.model"
import {environment} from "../../../../apps/frontend/src/environments/environment"
import {PayingMethodModel} from "../../../domain/src/lib/contact.model"


@Injectable({
  providedIn: 'root',
})
export class AccountingService {

  constructor(private readonly http: HttpClient) {
  }

  getBookings(): Observable<AccountingModel[]> {
    const url = `${environment.apiUrl}/rides`
    return this.http.get<AccountingModel[]>(url).pipe(
        map(value => {
          return value
        }),
    )
  }

  getBookingsByEventId(eventId: number): Observable<AccountingModel[]> {
    const url = `${environment.apiUrl}/rides/journal/events/${eventId}`
    return this.http.get<AccountingModel[]>(url).pipe(
        map(value => {
          return value
        }),
    )
  }

  getEditableBookingTexts(): Observable<JournalTextsModel[]> {
    const url = `${environment.apiUrl}/rides/journal/texts/editables`
    return this.http.get<JournalTextsModel[]>(url).pipe(
        map(value => {
          return value
        }),
    )
  }

  calcEventCosts(eventId: number): Observable<AccountingModel[]> {
    const url = `${environment.apiUrl}/rides/journal/events/${eventId}/costs`
    return this.http.post<AccountingModel[]>(url, eventId).pipe(
        map(value => {
          return value
        }),
    )
  }

  addDebitsForEvent(debits: JournalDebitModel): Observable<number> {
    const url = `${environment.apiUrl}/rides/journal/debits`
    // console.debug('addDebitsForEvent: url=', url, ', debits=', debits)
    return this.http.post<number>(url, debits).pipe(
        map(value => {
          return value
        }),
    )
  }

  addCreditsForEvent(credits: JournalCreditModel): Observable<number> {
    const url = `${environment.apiUrl}/rides/journal/credits`
    return this.http.post<number>(url, credits).pipe(
        map(value => {
          return value
        }),
    )
    // catchError(error => {
    //   logger.error(`Error: $error`)
    //   return of(null)
    // }),
  }

  deleteDebitsByEventId(eventId: number): Observable<number> {
    const url = `${environment.apiUrl}/rides/journal/events/${eventId}/debits`
    return this.http.delete<number>(url).pipe(
        map(value => {
          return value
        }),
    )
  }

  deleteCreditsByEventId(eventId: number): Observable<number> {
    const url = `${environment.apiUrl}/rides/journal/events/${eventId}/credits`
    return this.http.delete<number>(url).pipe(
        map(value => {
          return value
        }),
    )
  }

  deleteByBookingId(bookingId: number): Observable<number> {
    const url = `${environment.apiUrl}/rides/journal/${bookingId}`
    return this.http.delete<number>(url).pipe(
        map(value => {
          return value
        }),
    )
  }

  deleteByEventId(eventId: number): Observable<number> {
    const url = `${environment.apiUrl}/rides/journal/events/${eventId}`
    return this.http.delete<number>(url).pipe(
        map(value => {
          return value
        }),
    )
  }

  addBooking(booking: AccountingModel): Observable<number> {
    const url = `${environment.apiUrl}/rides/journal`
    return this.http.post<number>(url, booking).pipe(
        map(value => {
          return value
        }),
    )
  }

  changeBooking(booking: AccountingModel): Observable<number> {
    const url = `${environment.apiUrl}/rides/journal`
    return this.http.put<number>(url, booking).pipe(
        map(value => {
          return value
        }),
    )
  }

  sendReceipt(eventId: number, emailAddressId?: number): Observable<number> {
    const url = `${environment.apiUrl}/rides/journal/receipts/${eventId},${emailAddressId ?? 0}`
    return this.http.get<number>(url).pipe(
        map(value => {
          return value
        }),
    )
  }

  getPayingMethods(): Observable<PayingMethodModel[]> {
    const url = `${environment.apiUrl}/rides/journal/paying-methods`
    return this.http.get<PayingMethodModel[]>(url).pipe(
        map(values => {
          return values
        }),
    )
  }
}
